export default "__VITE_ASSET__BmQ5fx7r__"